module.exports = __webpack_public_path__ + "img/5.bbb30ad8.png";